import React from 'react';

/**
 * PendingApprovalBadge component
 * Displays a badge and message indicating that a wire is pending editorial review.
 * Used when a wire has approval_status: 'pending_approval' and is not yet published.
 */
export default function PendingApprovalBadge() {
  return (
    <>
      <div
        className="pending-approval-badge"
        style={{
          background: '#E67E22',
          color: '#FFFFFF',
          padding: '8px 12px',
          borderRadius: '6px',
          marginBottom: '12px',
          fontSize: '14px',
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        Pending Review
      </div>
      <div
        className="pending-approval-message"
        style={{
          color: '#666',
          fontSize: '14px',
          marginBottom: '12px',
          lineHeight: '1.4',
        }}
      >
        Your wire has been submitted for review. An editor will review and publish it soon.
      </div>
    </>
  );
}
